export type PluginType = 'bridge' | 'game' | 'tool' | 'utility';

export type StatusVariant = 'default' | 'secondary' | 'success' | 'warning' | 'info' | 'destructive';

export const formatStatusLabel = (value?: string | null) => {
  if (!value) return '—';
  return value
    .replaceAll('_', ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getStatusVariant = (status?: string | null): StatusVariant => {
  if (!status) return 'default';
  const normalized = status.toLowerCase();

  if (normalized.includes('published') || normalized.includes('approved') || normalized.includes('complete')) {
    return 'success';
  }
  if (normalized.includes('pending') || normalized.includes('review')) {
    return 'warning';
  }
  if (normalized.includes('reject') || normalized.includes('fail') || normalized.includes('error')) {
    return 'destructive';
  }
  if (normalized.includes('unpublished') || normalized.includes('draft')) {
    return 'secondary';
  }

  return 'info';
};

export const normalizePluginType = (
  type?: string | null,
  manifestType?: string | null
): PluginType => {
  const resolved = (type || manifestType || 'tool').toLowerCase();
  if (resolved === 'bridge' || resolved === 'game' || resolved === 'tool' || resolved === 'utility') {
    return resolved;
  }
  return 'tool';
};
